import { createRouter, createWebHistory  } from 'vue-router'
import Cookies from "js-cookie";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';


const router = createRouter({
  history: createWebHistory(),
  routes:[
    {
      path: '/',
      name: 'login',
      component: () => import('@/login/login.vue')
    },
    { //主界面
      path: '/index',
      name: 'index',
      component: () => import('@/views/home/index.vue'),
      redirect: '/HPV15fx',
      children: [
        {
          path: '/HPV15fx',
          name: 'HPV15fx',
          component: () => import('@/views/screenStatus/index.vue'),
        },
        {
          path: '/HPV23fx',
          name:'HPV23fx',
          component: () => import('@/views/HPV23fx/index.vue'),
        },
        {
          path: '/CCMethylation',
          name:'CCMethylation',
          component: () => import('@/views/CCMethylation/index.vue'),
        },
        {
          path: '/ps',
          name:'ps',
          component: () => import('@/views/QPS/index.vue'),
        },
        {
          path: '/specialExaminationForWomen',
          name:'specialExaminationForWomen',
          component: () => import('@/views/specialExaminationForWomen/index.vue'),
        }

      ]
    },
  ]
})

router.beforeEach((to, from, next) => {
  NProgress.start();
  const tokenkey = Cookies.get('token');
  if (tokenkey) {
    next();
  } else{
    if(to.path == '/'){   //判断是否已经进入登录页面path  防止死循环
       next()
    }else{
      next('/')
    }
  }
});

router.afterEach((to,from,next)=>{
  NProgress.done()   //进度条结束
})



export default router
